module.exports = __webpack_public_path__ + "img/4dcd1f8d37c692feb1a401c7d16b624e.6df061bd.jpg";